import { Navigate, Route, Routes } from 'react-router-dom';

import { User } from 'pages/user';

import { DiseasePetsTab, DiseaseTab } from 'widgets/disease';
import { VaccinePetsTab, VaccineTab } from 'widgets/vaccine';

import { AuthGuard } from 'features/auth';
import { CountriesPetsTab, CountriesTab } from 'features/countries';
import { PostVaccinationReactionsPetsTab, PostVaccinationReactionsTab } from 'features/post-vaccination-reactions';

import { routesApp } from 'shared/config';
import { BaseLayout, Header } from 'shared/ui';

import { Analytics } from './analytics';
import { AuthSendCode } from './auth-send-code';
import { AuthSendEmail } from './auth-send-email';
import { Breeds } from './breeds';
import { Main } from './main';
import { Pets } from './pets';
import { PharmaCompanies } from './pharma-companies';
import { SupportMessages } from './support-messages';
import { TranslationsPage } from './translations';
import { Users } from './users';
import { VoicesPage } from './voices';

const withGuard = (element: JSX.Element) => (
  <AuthGuard>
    <>
      <Header />
      {element}
    </>
  </AuthGuard>
);

export const Routing = () => {
  return (
    <BaseLayout>
      <Routes>
        <Route path={routesApp.sendEmail} element={<AuthSendEmail />} />
        <Route path={routesApp.sendCode} element={<AuthSendCode />} />

        <Route path={routesApp.peoples} element={withGuard(<Main />)}>
          <Route index element={<Navigate to={routesApp.peoplesVaccines} replace />} />
          <Route path="vaccines" element={<VaccineTab />} />
          <Route path="diseases" element={<DiseaseTab />} />
          <Route path="countries" element={<CountriesTab />} />
          <Route path="reactions" element={<PostVaccinationReactionsTab />} />
        </Route>

        <Route path={routesApp.pets} element={withGuard(<Pets />)}>
          <Route index element={<Navigate to={routesApp.petsVaccines} replace />} />
          <Route path="vaccines" element={<VaccinePetsTab />} />
          <Route path="diseases" element={<DiseasePetsTab />} />
          <Route path="countries" element={<CountriesPetsTab />} />
          <Route path="breeds" element={<Breeds />} />
          <Route path="reactions" element={<PostVaccinationReactionsPetsTab />} />
        </Route>

        <Route path={routesApp.users} element={withGuard(<Users />)} />
        <Route path={`${routesApp.users}/:id`} element={withGuard(<User />)} />
        <Route path={routesApp.breeds} element={withGuard(<Breeds />)} />
        <Route path={routesApp.voices} element={withGuard(<VoicesPage />)} />
        <Route path={routesApp.translations} element={withGuard(<TranslationsPage />)} />
        <Route path={routesApp.pharmaCompanies} element={withGuard(<PharmaCompanies />)} />
        <Route path={routesApp.analytics} element={withGuard(<Analytics />)} />
        <Route path={routesApp.supportMessages} element={withGuard(<SupportMessages />)} />
      </Routes>
    </BaseLayout>
  );
};
